const Spinner = () => {
	return (
		<div role='status'>
			<span style={{ fontSize: '2rem' }}>Loading...</span>
		</div>
	);
};

export default Spinner;
